(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/components/loader.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/components/loader.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const Loader = () => {
  useEffect(() => {
    svs.components.loader.show();
    return () => svs.components.loader.hide();
  });
  return React.createElement("div", null);
};
setGlobal('svs.kenoXpress.react.components.Loader', Loader);

 })(window);